import { Alignment, Direction, Displaying, Spacing } from "@bonusx-global/bx-design-system";
import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const TwoButtonsWarningModalTextWrapper = styled(Box)({
  display: Displaying.flex,
  flexDirection: Direction.column,
  alignItems: Alignment.center,
  justifyContent: Alignment.center,
  gap: Spacing[1000],
});
